// cleanup_convert_to_typescript_file_GENERICS_TRANSFERS

import { createUseStyles } from '@glu/theming';

const styles = ({ spacing: { unit } }) => ({
  modalDialog: {
    '& p': {
      marginBottom: 1 * unit
    }
  }
});

export default createUseStyles(styles);
